/**
 * Aktion: Daten ändern
 *
 * @param {Object} a_currentValues  Aktuelle Domaindaten
 * @param {Object} a_newValues      Neue Domaindaten
 *
 * @return {Object}
 */
export function getUpdatedValues( a_currentValues, a_newValues )
{
	const updatedValues = {};
	
	if ( JSON.stringify( a_currentValues ) !== JSON.stringify( a_newValues ) )
	{
		Object.keys( a_newValues ).forEach(
			a_key =>
			{
				if ( a_currentValues[ a_key ] !== a_newValues[ a_key ] )
				{
					if ( typeof a_newValues[ a_key ].toISOString === "function" )
					{
						updatedValues[ a_key ] = a_newValues[ a_key ].toLocaleDateString();
					}
					else
					{
						updatedValues[ a_key ] = a_newValues[ a_key ];
					}
				}
			}
		);
		
		if ( Object.keys( updatedValues ).length !== 0 )
		{
			updatedValues[ "id" ] = a_currentValues.id;
		}
	}
	
	// Nur die Änderungen zurückgeben
	return updatedValues;
	
} // function getUpdatedValues(...)